// extracted by mini-css-extract-plugin
module.exports = {"flow":"Flow_flow__ngdVe","flowBlockContent":"Flow_flowBlockContent__Hw7HW"};